import {
  configActions,
  socketActions,
  preloaderActions,
} from '../actions';
import { gettingCredentialsFailed, setCredentials } from '../reducers/chat';
import { configActionsFromSlice } from '../reducers/config';

export const CHANGE_LANGUAGE = 'change_language';
export const ERROR_SHOW = 'error_show';
export const DIALOG_SHOW = 'dialog_show';
export const VIDEO_ERROR = 'video_error';
export const NO_BALANCE = 'no_balance';
export const DISCONNECT_SHOW = 'disconnect_show';
export const DISCONNECT_CLICK = 'disconnect_click';
export const REALITY_CHECK_ACTION = 'reality_check_action';
export const OPERATOR_ERROR_ACTION = 'operator_error_action';
export const AUTO_ADJUST = 'auto_adjust';
export const GAME_LOADING = 'game_loading';
export const GAME_LOADED = 'game_loaded';
export const HOME_CLICK = 'home_click';
export const PLAYER_DETAILED_HISTORY_CLICK = 'player_detailed_history_click';
export const CASHIER_CLICK = 'cashier_click';
export const HIDE_OTHERS_CHAT = 'hide_others_chat';
export const GAME_SOUNDS = 'game_sounds';
export const BACKGROUND_MUSIC = 'background_music';
export const GAME_VOLUME = 'game_volume';
export const VIDEO_STREAM_SOUNDS = 'video_stream_sounds';
export const OPEN_MINI_LOBBY = 'open_mini_lobby';
export const OPEN_MINI_LOBBY_TABLE = 'open_mini_lobby_table';
export const TOGGLE_TIPS = 'toggle_tips';
export const SEND_TIP = 'send_tip';
export const BET_ACTION_REBET = 'bet_action_rebet';
export const BET_ACTION_DOUBLE = 'bet_action_double';
export const BET_ACTION_UNDO = 'bet_action_undo';
export const BET_ACTION_CLEAR = 'bet_action_clear';
export const BET_ACTION_REQUEST = 'bet_action_request';
export const SELECT_CHIP = 'select_chip';
export const CHANGE_DEFAULT_CHIP = 'change_default_chip';
export const LAST_BET_ACTION = 'last_bet_action';
export const VIDEO_QUALITY_SET = 'video_quality_set';
export const HIDE_UI = 'hide_ui';
export const DIRECT_LINK = 'direct_link_table';
export const REFERRER_URLS_TO_IGNORE = [
  'livetables.io',
  'livetablesnj.com',
  'livetableshu.com',
];
export const PN_DECLINE = 'pn_decline'; // video blackjack, privacy notice declined
export const PN_ACCEPT = 'pn_accept'; // video blackjack, privacy notice accepted
export const PN_DOWNLOAD = 'pn_download'; // video blackjack, privacy notice downloaded
export const TAP_TO_PLAY = 'tap_to_play'; // on all handheld devices, tap to start the game
export const TAP_TO_PLAY_VISIBLE = 'tap_to_play_visible'; // on all handheld devices, when preloader is mounted
export const VIDEO_STATUS_EVENT = 'VIDEO_STATUS';
export const INJECT_ANALYTICS_FAIL = 'analytics_fail';
export const GAMES_GAME_INFO = 'games_game_info';
export const GAMES_SUPPORT_CHAT = 'games_support_chat';
export const GAMES_CHAT_CLICKED = 'games_chat_clicked';
export const GAMES_FULLSCREEN = 'games_fullscreen';
export const MINI_LOBBY_CATEGORY_CLICK = 'mini_lobby_category_click';
export const LOBBY_FAVORITE = 'lobby_favorite';
export const CHAT_LOADING = 'chat_loading';
export const GAME_MENU_LIMITS_PAYOUTS = 'game_menu_limits_payouts';
export const GAME_MENU_PLAYER_HISTORY_CLICK = 'game_menu_player_history_click';
export const CHANGE_ORIENTATION = 'change_orientation';
export const GAME_MENU_PLAYER_HISTORY_DAILY = 'game_menu_player_history_daily';

export const CASHIER_SOURCE = {
  LOW_BALANCE: 'low_balance',
  MENU: 'menu',
  GAME_FOOTER: 'game_footer',
  BONUS_WHEEL_INSUFFICIENT_BALANCE: 'bonus_wheel_insufficient_balance',
};

export const VIDEO_EVO = 'Evo';
export const VIDEO_NANO = 'Nano';

const normalizedConfigActions = import.meta.env.MODE !== 'test'
  ? configActions.config : (configActions.config || configActionsFromSlice);

export const PERFORMANCE_LOAD_TABLE_CONFIG_LOADING_STATUS_MAP = {
  [normalizedConfigActions.request.type]: 'load_table_config_request',
  [normalizedConfigActions.success.type]: 'load_table_config_success',
  [normalizedConfigActions.failure.type]: 'load_table_config_error',
};

export const PERFORMANCE_ENGINE_LOADING_STATUS_MAP = {
  [socketActions.socket.failure.type]: 'engine_error',
  [socketActions.socket.success.type]: 'engine_success',
  [socketActions.socket.request.type]: 'engine_request',
};

export const PERFORMANCE_GET_USER_LOADING_STATUS_MAP = {
  [gettingCredentialsFailed.type]: 'error',
  [setCredentials.type]: 'success',
  [preloaderActions.preloader.hide.type]: 'initialization',
};
